<!--
 * @Author: ZhaoG
 * @Date: 2025-04-29 17:43:09
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-07-30 15:40:30
 * @FilePath: \gcp-fe\src\app\contactUs\views\index.vue
 * @Description: 联系我们
-->
<template>
  <div class="contactUs">
    <div class="contentMain">
      <base-bread-crumb
        class="bread-crumb"
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="true"
      ></base-bread-crumb>
    </div>
    <div class="mainBox">
      <div class="contentMain">
        <div class="title">{{ $t("page.content.contactUs") }}</div>
        <p v-for="item in items" :key="item">{{ item }}</p>
        <div class="title">{{ $t("page.content.onlineService") }}</div>
        <div class="online-service" @click="goOnlineService">
          <img src="@/basa/assets/images/kf.png" alt="" srcset="" />
          <span>{{ $t("page.content.onlineService") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadCrumb from "../../noticesList/components/baseBreadCrumb";
export default {
  name: "announcement-list-revoked",
  components: {
    BaseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [
        {
          title: this.$t("page.content.contactUs")
        }
      ],
      items: []
    };
  },
  created() {
    this.items = [
      this.$t("page.content.contactUsPostcodeFull"),
      this.$t("page.content.supplierOperationPhone"),
      this.$t("page.content.subcontractorSupplyChainPhone"),
      this.$t("page.content.winningBidServiceFeePhone"),
      this.$t("page.content.consultTimeFull"),
      this.$t("page.content.supplierContactEmail"),
      this.$t("page.content.contactUsAddress")
    ];
  },
  methods: {
    goOnlineService() {
      const zx = document.querySelector(".app-item.zaixian");
      zx && zx.click();
      // window.open(
      //   "https://work.weixin.qq.com/kfid/kfca8000d191a60882f",
      //   "_blank"
      // );
    }
  }
};
</script>

<style lang="scss" scoped>
.contactUs {
  width: 100%;
  background: #eaeaea;

  .contentMain {
    width: 1180px;
    margin: 0 auto;
  }

  .mainBox {
    width: 100%;
    min-height: 487px;
    background: #fff;
    padding-bottom: 30px;

    .title {
      width: 100%;
      padding: 20px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #4a4a4a;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 20px;
    }

    p {
      padding: 0 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #4a4a4a;
      margin-bottom: 20px;
    }

    .online-service {
      //   padding: 0 30px;
      margin-left: 30px;
      width: 150px;
      height: 44px;
      background: linear-gradient(180deg, #6b98ff 0%, #4672ff 100%);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}

.bread-crumb {
  padding: 10px 0;
  margin: 0 !important;
}
</style>
